(function() {
  define('bazemont/booking/form',['angular', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('bazemontBookingForm', ['ngAnimate', 'ui.bootstrap']).component('bazemontBookingForm', {
      templateUrl: '/assets/javascripts/bazemont/booking/form.html',
      bindings: {
        bookingRequest: '='
      },
      require: {
        bazemontBookingPageCtrl: '^^bazemontBookingPage'
      },
      controller: [
        '$uibModal', function($uibModal) {
          var vm;
          vm = this;
          vm.submit = function() {
            if (vm.form.$valid) {
              return $uibModal.open({
                templateUrl: '/assets/javascripts/bazemont/booking/modal.html',
                controllerAs: '$ctrl',
                bindToController: true,
                resolve: {
                  data: {
                    bookingRequest: vm.bookingRequest
                  }
                },
                controller: [
                  '$uibModalInstance', '$http', '$window', 'data', function($uibModalInstance, $http, $window, data) {
                    var mvm;
                    mvm = this;
                    mvm.bookingRequest = angular.copy(data.bookingRequest);
                    mvm.getFullAddress = function() {
                      return mvm.bookingRequest.address + (mvm.bookingRequest.isLocal ? ', 78580, Bazemont' : ', ' + mvm.bookingRequest.zipCode + ', ' + mvm.bookingRequest.city);
                    };
                    mvm.submit = function() {
                      mvm.error = null;
                      if (!mvm.submitting) {
                        mvm.submitting = true;
                        return $http.post('/api/booking/request', mvm.bookingRequest).then(function(response) {
                          return $window.location.href = response.data.url;
                        })["catch"](function(error) {
                          console.error(error);
                          mvm.error = error.data && error.data.msg ? error.data.msg : "Erreur inattendue, veuillez contacter l'administrateur.";
                          if (error.data && error.data.isBookedDate) {
                            return vm.bazemontBookingPageCtrl.loadSelectableDates(mvm.bookingRequest.item);
                          }
                        })["finally"](function() {
                          return mvm.submitting = false;
                        });
                      }
                    };
                    mvm.close = function() {
                      return $uibModalInstance.dismiss();
                    };
                  }
                ]
              });
            }
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=form.js.map
;
